module.exports = "https://www.gc-pro.gnp.com.mx/23439211c4d304c8805b6d78a0f84c56.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/exclamation-naranja.png
// module id = 326
// module chunks = 0